import { render, staticRenderFns } from "./ForeignChecks.vue?vue&type=template&id=4c232352&scoped=true"
import script from "./ForeignChecks.vue?vue&type=script&lang=js"
export * from "./ForeignChecks.vue?vue&type=script&lang=js"
import style0 from "./ForeignChecks.vue?vue&type=style&index=0&id=4c232352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c232352",
  null
  
)

export default component.exports